<app-user-info [user]="currentUser"></app-user-info>
<mat-divider class="user-info-divider"></mat-divider>
<div class="user-profile-wrapper" *ngIf="(hasLoaded|async)" [@fadeInOut]>
  <div class="accordion-wrapper" [class.multi]="multiAccordion" [@fadeInOut]>
    <mat-accordion [multi]="multiAccordion" [hideToggle]="multiAccordion">
      <mat-expansion-panel *ngxPermissionsOnly="['torchGlobalAdmin', 'torchAdmin']" [expanded]="multiAccordion"
                           [disabled]="multiAccordion">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon class="expansion-icon">security</mat-icon>
            Roles
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-manage-user-roles [user]="currentUser"></app-manage-user-roles>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="multiAccordion" [hideToggle]="multiAccordion" [disabled]="multiAccordion">
        <mat-expansion-panel-header>
          <mat-icon class="expansion-icon">assignment</mat-icon>
          Part Health Log
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <app-recent-part-health [user]="currentUser.username"></app-recent-part-health>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="multiAccordion" [hideToggle]="multiAccordion" [disabled]="multiAccordion ">
        <mat-expansion-panel-header>
          <mat-icon class="expansion-icon">attachment</mat-icon>
          Files - {{totalUserFiles|async}}
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <app-user-files-list (totalFiles)="fileCountUpdated($event)" [username]="currentUser.username"></app-user-files-list>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>

<div class="placeholder" *ngIf="!(hasLoaded|async)">
  <div class="loading-shade" *ngIf="expanded">
    <mat-spinner></mat-spinner>
  </div>
</div>

